var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { class: _vm.embedded ? "" : "ma-5", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { class: _vm.embedded ? "pa-3" : "" },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "d-flex justify-center align-center py-8" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : _vm.error
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: { type: "error", outlined: "", dense: "" },
                },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : _vm.info
            ? _c("div", { staticClass: "system-info-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "balance-card mb-2",
                    class: { "balance-low": _vm.isBalanceLow },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "balance-header" },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              color: _vm.isBalanceLow ? "white" : "teal",
                              size: "28",
                            },
                          },
                          [_vm._v("mdi-phone")]
                        ),
                        _c("span", { staticClass: "balance-label" }, [
                          _vm._v(_vm._s(_vm.$t("twilio-balance"))),
                        ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "balance-value" }, [
                      _vm._v(" " + _vm._s(_vm.formattedBalance) + " "),
                    ]),
                    _vm.isBalanceLow
                      ? _c(
                          "div",
                          { staticClass: "balance-warning" },
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", color: "white" } },
                              [_vm._v("mdi-alert")]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("low-balance-warning"))),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _c("div", { staticClass: "env-section mb-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "env-header",
                      on: {
                        click: function ($event) {
                          _vm.envExpanded = !_vm.envExpanded
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "white", size: "16" },
                            },
                            [_vm._v("mdi-console")]
                          ),
                          _c("span", [_vm._v("Environment Variables")]),
                          _c(
                            "v-chip",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                "x-small": "",
                                color: "white",
                                "text-color": "grey darken-2",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.envCount) + " ")]
                          ),
                          _c(
                            "v-icon",
                            {
                              staticClass: "ml-2",
                              attrs: { color: "white", size: "16" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.envExpanded
                                    ? "mdi-chevron-up"
                                    : "mdi-chevron-down"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "copy-all-btn",
                          attrs: { "x-small": "", text: "", color: "white" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.copyAllEnv.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                            _vm._v("mdi-content-copy"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("copy-all")) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.envExpanded
                    ? _c(
                        "div",
                        { staticClass: "env-content" },
                        [
                          !_vm.info.env ||
                          Object.keys(_vm.info.env).length === 0
                            ? _c("div", { staticClass: "env-row" }, [
                                _c("span", { staticClass: "env-key" }, [
                                  _vm._v("No environment variables available"),
                                ]),
                              ])
                            : _vm._l(_vm.info.env, function (value, key) {
                                return _c(
                                  "div",
                                  { key: key, staticClass: "env-row" },
                                  [
                                    _c("span", { staticClass: "env-key" }, [
                                      _vm._v(_vm._s(key)),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "env-value-wrapper" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "env-val",
                                            class: {
                                              redacted: value === "<redacted>",
                                              "expandable-value":
                                                value !== "<redacted>",
                                              "text-truncate":
                                                value !== "<redacted>" &&
                                                !_vm.isExpanded("env-" + key),
                                            },
                                            attrs: { title: value },
                                            on: {
                                              click: function ($event) {
                                                value !== "<redacted>" &&
                                                  _vm.toggleExpand("env-" + key)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(value || "-") + " "
                                            ),
                                          ]
                                        ),
                                        value && value !== "<redacted>"
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "copy-btn",
                                                attrs: {
                                                  icon: "",
                                                  "x-small": "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.copyToClipboard(
                                                      value
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { "x-small": "" } },
                                                  [_vm._v("mdi-content-copy")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "info-sections" }, [
                  _c("div", { staticClass: "info-section gcp-section" }, [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "white", size: "20" } },
                          [_vm._v("mdi-google-cloud")]
                        ),
                        _c("span", [_vm._v("Google Cloud")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("project"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c("span", { staticClass: "info-value" }, [
                              _vm._v(_vm._s(_vm.info.gcp?.project || "-")),
                            ]),
                            _vm.info.gcp?.project
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.gcp.project
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("environment"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "v-chip",
                              {
                                staticClass: "env-chip",
                                attrs: {
                                  "x-small": "",
                                  color: _vm.envColor,
                                  dark: "",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.info.gcp?.env || "-") + " "
                                ),
                              ]
                            ),
                            _vm.info.gcp?.env
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.gcp.env
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("API"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate": !_vm.isExpanded("gcp-api"),
                                },
                                attrs: { title: _vm.info.gcp?.api },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("gcp-api")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.info.gcp?.api || "-") + " "
                                ),
                              ]
                            ),
                            _vm.info.gcp?.api
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.gcp.api
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("App"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate": !_vm.isExpanded("gcp-app"),
                                },
                                attrs: { title: _vm.info.gcp?.app },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("gcp-app")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.info.gcp?.app || "-") + " "
                                ),
                              ]
                            ),
                            _vm.info.gcp?.app
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.gcp.app
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("port"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c("span", { staticClass: "info-value" }, [
                              _vm._v(_vm._s(_vm.info.gcp?.port || "-")),
                            ]),
                            _vm.info.gcp?.port
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.gcp.port
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-section redis-section" }, [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "white", size: "20" } },
                          [_vm._v("mdi-database")]
                        ),
                        _c("span", [_vm._v("Redis")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("host"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c("span", { staticClass: "info-value" }, [
                              _vm._v(_vm._s(_vm.info.redis?.host || "-")),
                            ]),
                            _vm.info.redis?.host
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.redis.host
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("port"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c("span", { staticClass: "info-value" }, [
                              _vm._v(_vm._s(_vm.info.redis?.port || "-")),
                            ]),
                            _vm.info.redis?.port
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.redis.port
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("DB"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c("span", { staticClass: "info-value" }, [
                              _vm._v(_vm._s(_vm.info.redis?.db || "-")),
                            ]),
                            _vm.info.redis?.db
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.redis.db
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("status"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  "x-small": "",
                                  color: _vm.redisStatusColor,
                                  dark: "",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.info.redis?.status || "-") +
                                    " "
                                ),
                              ]
                            ),
                            _vm.info.redis?.status
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.redis.status
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-section firestore-section" }, [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "white", size: "20" } },
                          [_vm._v("mdi-firebase")]
                        ),
                        _c("span", [_vm._v("Firestore")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("database"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c("span", { staticClass: "info-value" }, [
                              _vm._v(
                                _vm._s(_vm.info.firestore?.database || "-")
                              ),
                            ]),
                            _vm.info.firestore?.database
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.firestore.database
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row collections-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("collections"))),
                        ]),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.collectionsCount)),
                        ]),
                      ]),
                      _vm.info.firestore?.collections?.length
                        ? _c(
                            "div",
                            { staticClass: "collections-list" },
                            [
                              _vm._l(
                                _vm.displayedCollections,
                                function (collection) {
                                  return _c(
                                    "v-chip",
                                    {
                                      key: collection,
                                      staticClass: "collection-chip mr-1 mb-1",
                                      attrs: { "x-small": "", outlined: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyToClipboard(collection)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(collection) + " ")]
                                  )
                                }
                              ),
                              _vm.hiddenCollectionsCount > 0 &&
                              !_vm.collectionsExpanded
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "mr-1 mb-1 expand-chip",
                                      attrs: {
                                        "x-small": "",
                                        color: "grey",
                                        dark: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.collectionsExpanded = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " +" +
                                          _vm._s(_vm.hiddenCollectionsCount) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.collectionsExpanded &&
                              _vm.info.firestore?.collections?.length >
                                _vm.maxVisibleCollections
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "mr-1 mb-1 expand-chip",
                                      attrs: {
                                        "x-small": "",
                                        color: "grey",
                                        outlined: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.collectionsExpanded = false
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "", left: "" } },
                                        [_vm._v("mdi-chevron-up")]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("less")) + " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-section twilio-section" }, [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "white", size: "20" } },
                          [_vm._v("mdi-phone")]
                        ),
                        _c("span", [_vm._v("Twilio")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("account"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("twilio-account"),
                                },
                                attrs: { title: _vm.info.twilio?.account },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("twilio-account")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.info.twilio?.account || "-") +
                                    " "
                                ),
                              ]
                            ),
                            _vm.info.twilio?.account
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.twilio.account
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("TwiML"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("twilio-twiml"),
                                },
                                attrs: { title: _vm.info.twilio?.twiml },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("twilio-twiml")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.info.twilio?.twiml || "-") +
                                    " "
                                ),
                              ]
                            ),
                            _vm.info.twilio?.twiml
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.twilio.twiml
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("auth"))),
                        ]),
                        _c("span", { staticClass: "info-value redacted" }, [
                          _vm._v(_vm._s(_vm.info.twilio?.auth || "-")),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-section algolia-section" }, [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "white", size: "20" } },
                          [_vm._v("mdi-magnify")]
                        ),
                        _c("span", [_vm._v("Algolia")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("App ID"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c("span", { staticClass: "info-value" }, [
                              _vm._v(_vm._s(_vm.info.algolia?.app || "-")),
                            ]),
                            _vm.info.algolia?.app
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.algolia.app
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("key"))),
                        ]),
                        _c("span", { staticClass: "info-value redacted" }, [
                          _vm._v(_vm._s(_vm.info.algolia?.key || "-")),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-section gmail-section" }, [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "white", size: "20" } },
                          [_vm._v("mdi-gmail")]
                        ),
                        _c("span", [_vm._v("Gmail")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Client ID"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("gmail-clientId"),
                                },
                                attrs: {
                                  title: _vm.info.email?.gmail?.clientId,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("gmail-clientId")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.info.email?.gmail?.clientId || "-"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.info.email?.gmail?.clientId
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.email.gmail.clientId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Secret"),
                        ]),
                        _c("span", { staticClass: "info-value redacted" }, [
                          _vm._v(
                            _vm._s(_vm.info.email?.gmail?.clientSecret || "-")
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Redirect"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("gmail-redirect"),
                                },
                                attrs: {
                                  title: _vm.info.email?.gmail?.redirectUrl,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("gmail-redirect")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.info.email?.gmail?.redirectUrl || "-"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.info.email?.gmail?.redirectUrl
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.email.gmail.redirectUrl
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row scope-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Scope"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "info-value expandable-value scope-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("gmail-scope"),
                                },
                                attrs: { title: _vm.info.email?.gmail?.scope },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("gmail-scope")
                                  },
                                },
                              },
                              [
                                _vm.isExpanded("gmail-scope") &&
                                _vm.info.email?.gmail?.scope
                                  ? _vm._l(
                                      _vm.formatGmailScope(
                                        _vm.info.email.gmail.scope
                                      ),
                                      function (s, i) {
                                        return _c(
                                          "div",
                                          { key: i, staticClass: "scope-item" },
                                          [_vm._v(" " + _vm._s(s) + " ")]
                                        )
                                      }
                                    )
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.info.email?.gmail?.scope || "-"
                                          ) +
                                          " "
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _vm.info.email?.gmail?.scope
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.email.gmail.scope
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Topic"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("gmail-topic"),
                                },
                                attrs: { title: _vm.info.email?.gmail?.topic },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("gmail-topic")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.info.email?.gmail?.topic || "-"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.info.email?.gmail?.topic
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.email.gmail.topic
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-section outlook-section" }, [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "white", size: "20" } },
                          [_vm._v("mdi-microsoft-outlook")]
                        ),
                        _c("span", [_vm._v("Outlook")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Client ID"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("outlook-clientId"),
                                },
                                attrs: {
                                  title: _vm.info.email?.outlook?.clientId,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("outlook-clientId")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.info.email?.outlook?.clientId || "-"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.info.email?.outlook?.clientId
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.email.outlook.clientId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Secret"),
                        ]),
                        _c("span", { staticClass: "info-value redacted" }, [
                          _vm._v(
                            _vm._s(_vm.info.email?.outlook?.clientSecret || "-")
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Redirect"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "info-value expandable-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("outlook-redirect"),
                                },
                                attrs: {
                                  title: _vm.info.email?.outlook?.redirectUrl,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("outlook-redirect")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.info.email?.outlook?.redirectUrl ||
                                        "-"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.info.email?.outlook?.redirectUrl
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.email.outlook.redirectUrl
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "info-row scope-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("Scope"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "info-value expandable-value scope-value",
                                class: {
                                  "text-truncate":
                                    !_vm.isExpanded("outlook-scope"),
                                },
                                attrs: {
                                  title: _vm.info.email?.outlook?.scope,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand("outlook-scope")
                                  },
                                },
                              },
                              [
                                _vm.isExpanded("outlook-scope") &&
                                _vm.info.email?.outlook?.scope
                                  ? _vm._l(
                                      _vm.formatOutlookScope(
                                        _vm.info.email.outlook.scope
                                      ),
                                      function (s, i) {
                                        return _c(
                                          "div",
                                          { key: i, staticClass: "scope-item" },
                                          [_vm._v(" " + _vm._s(s) + " ")]
                                        )
                                      }
                                    )
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.info.email?.outlook?.scope ||
                                              "-"
                                          ) +
                                          " "
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _vm.info.email?.outlook?.scope
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.info.email.outlook.scope
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-section gcs-section" }, [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "white", size: "20" } },
                          [_vm._v("mdi-bucket")]
                        ),
                        _c("span", [_vm._v("Cloud Storage")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(_vm._s(_vm.$t("bucket"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "info-value-wrapper" },
                          [
                            _c("span", { staticClass: "info-value" }, [
                              _vm._v(_vm._s(_vm.info.gcs?.bucket || "-")),
                            ]),
                            _vm.info.gcs?.bucket
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { icon: "", "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          _vm.info.gcs.bucket
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-content-copy"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }